var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.4429 18.0977L21.7511 8.06741C21.6425 6.49269 21.5882 5.70533 21.2469 5.10848C20.9465 4.58299 20.494 4.16069 19.9491 3.89707C19.3302 3.59766 18.541 3.59766 16.9625 3.59766H7.92324C6.34478 3.59766 5.55556 3.59766 4.93663 3.89707C4.39171 4.16069 3.93929 4.58299 3.63881 5.10848C3.29751 5.70533 3.24321 6.49269 3.13461 8.0674L2.44287 18.0977M22.4429 18.0977C22.4429 20.0307 20.8759 21.5977 18.9429 21.5977H5.94287C4.00987 21.5977 2.44287 20.0307 2.44287 18.0977M22.4429 18.0977C22.4429 16.1647 20.8759 14.5977 18.9429 14.5977H5.94287C4.00987 14.5977 2.44287 16.1647 2.44287 18.0977M6.44287 18.0977H6.45287M12.4429 18.0977H18.4429",
    stroke: "#7BA4D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveicon);
export default __webpack_public_path__ + "static/media/drive.icon.75142399210627217ac6b888974aaa79.svg";
export { ForwardRef as ReactComponent };